/**
 * render-live-streaming
 *
 * @author    Alexis Vedia <alexis.vedia@mediatel.co.uk>
 * @copyright 2017 Mediatel Limited.
 */

"use strict";

import numberFormat from "../common/number-format";
import infoboxTooltip from "../common/infobox-tooltip";
import LiveStreamingMessage from "../tv-player-report/other-platform-message/live-streaming-message";

export default (data, options) => {
    if(! data.length) {
        return 'No data for this period';
    }

    const decimals = 0;
    const stationHtml = [];

    const rows = data.map((stationData, i) => {
        let tooltip = stationData.other_apps !== "0"
            ? infoboxTooltip(LiveStreamingMessage(stationData, decimals))
            : '';

        return `<tr class="${i % 2 === 0 ? "even" : "odd"}">` +
            `<td class="number align_left">${stationData.name}</td>` +
            `<td class="number align_center">${(stationData.total_playtime && stationData.total_playtime != 0) ? numberFormat(stationData.total_playtime, decimals) : '-'}</td>` +
            `<td class="number align_center">${(stationData.own_apps && stationData.own_apps != 0) ? numberFormat(stationData.own_apps, decimals) : '-'}</td>` +
            `<td class="number align_center">${(stationData.other_apps && stationData.other_apps != 0) ? numberFormat(stationData.other_apps, decimals) : '-'} ${tooltip}</td>` +
        `</tr>`;
    }).join("\n");

    stationHtml.push(`<table class="datagrid sortable">` +
        `<thead><tr>` +
        `<th data-sort-method="text" class="no_bkgd align_left soft">${options.labelTableName}</th>` +
        `<th data-sort-method="number" class="no_bkgd align_center soft">Total minutes</th>` +
        `<th data-sort-method="number" class="no_bkgd align_center soft">Own apps</th>` +
        `<th data-sort-method="number" class="no_bkgd align_center soft">Other platforms</th>` +
        `</tr></thead><tbody>${rows}</tbody></table>`
    );

    return stationHtml.join("\n");
}
